// src/components/TokenHandler.jsx

import React, { useContext, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";

const TokenHandler = () => {
  const { auth, login } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token && token !== auth.token) {
      try {
        const user = jwtDecode(token);
        login({ token, user });
      } catch (error) {
        console.error("Error decoding token:", error);
      }
      // Clean up the URL so the token is not processed again
      navigate("/", { replace: true });
    }
  }, [searchParams, login, navigate, auth.token]);

  return null;
};

export default TokenHandler;
